import { onMounted } from 'vue';

const lastScrollOpt = {
  name: '',
  scrollTop: 0,
};

export function setRestorePosition(scrollTop = 0) {
  lastScrollOpt.scrollTop = scrollTop;
}

export default function useRestoreScroll(elRef, name, shouldRestore) {
  onMounted(() => {
    if (!shouldRestore) {
      return;
    }

    if (elRef.value && name === lastScrollOpt.name && lastScrollOpt.scrollTop > 0) {
      elRef.value.scrollTop = lastScrollOpt.scrollTop;
    }

    lastScrollOpt.name = name;
  });

  const setPosition = (scrollTop = elRef.value?.scrollTop) => {
    setRestorePosition(scrollTop);
  };

  return {
    setPosition: shouldRestore ? setPosition : () => {},
  };
}
